import React from 'react'

const VideoPlayerIcon = ({ width = '1em', height = '1em', fill = '#000', ...props }) => (
  <svg fill={fill} width={width} height={height} {...props} viewBox='0 0 84 48' xmlns='http://www.w3.org/2000/svg'>
    <g fillRule='evenodd'>
      <rect width='84' height='48' rx='12' />
      <path
        d='M35 15.713v16.601a1 1 0 0 0 1.48.878l14.94-8.163a1 1 0 0 0 .013-1.748l-14.941-8.439a1 1 0 0 0-1.492.871z'
        fill='#fff'
      />
    </g>
  </svg>
)

export default VideoPlayerIcon
